/** Resolve the user's single app role from session/API shapes (current and legacy). */
export function getUserRole(user) {
  if (!user) return null;

  if (typeof user.role === "string") {
    const trimmed = user.role.trim();
    if (trimmed) return trimmed;
  }

  if (Array.isArray(user.roles) && user.roles.length) {
    const trimmed = String(user.roles[0]).trim();
    if (trimmed) return trimmed;
  }

  if (user.app_role?.name) {
    const trimmed = String(user.app_role.name).trim();
    if (trimmed) return trimmed;
  }

  return null;
}

export function hasRole(user, role) {
  const userRole = getUserRole(user);
  if (!userRole || !role) return false;
  return userRole === role || userRole.toLowerCase() === String(role).toLowerCase();
}

export function hasAnyRole(user, roles) {
  return roles.some((role) => hasRole(user, role));
}

export function isAdministrator(user) {
  return hasRole(user, "administrator");
}

export function isTechnician(user) {
  return hasRole(user, "technician");
}

export function isCustomer(user) {
  return hasRole(user, "customer");
}

export const TECHNICIAN_HOME = "/ecrane/list";
export const CUSTOMER_HOME = "/my-cranes";

export function getDefaultRoute(user) {
  if (isTechnician(user)) return TECHNICIAN_HOME;
  if (isCustomer(user)) return CUSTOMER_HOME;
  return "/dashboard";
}

export function isTechnicianRestrictedPath(pathname) {
  if (!pathname) return false;
  return (
    pathname === "/dashboard" ||
    pathname.startsWith("/dashboard/") ||
    pathname === "/prospect" ||
    pathname.startsWith("/prospect/") ||
    pathname === "/fsr" ||
    pathname.startsWith("/fsr/") ||
    pathname === "/map-view" ||
    pathname.startsWith("/map-view/")
  );
}
